<article
  class="source-card"
  [class.source-card--active]="active()"
  [class.source-card--disabled]="!source().available"
>
  <div class="source-card__body">
    <img
      class="source-card__logo"
      [src]="source().logoSrc"
      [alt]="source().nameKey | translate"
      width="48"
      height="48"
    />
    <h3 class="source-card__name">{{ source().nameKey | translate }}</h3>
    <p class="source-card__description">
      {{ source().descriptionKey | translate }}
    </p>
    <div class="source-card__badge-slot">
      @if (!source().available && source().comingSoonKey) {
        <span class="source-card__badge">{{
          source().comingSoonKey! | translate
        }}</span>
      }
    </div>
  </div>

  <div class="source-card__footer">
    <button
      type="button"
      class="source-toggle"
      role="switch"
      [class.source-toggle--on]="active()"
      [disabled]="!source().available"
      [attr.aria-checked]="active()"
      [attr.aria-label]="source().nameKey | translate"
      (click)="onToggleClick($event)"
    >
      <span class="source-toggle__track" aria-hidden="true">
        <span class="source-toggle__thumb"></span>
      </span>
    </button>

    @if (active() && source().available) {
      <a
        class="source-card__manage"
        [routerLink]="['/', source().route]"
        [attr.aria-label]="
          'app.patrol.communities.manage' | translate: { name: (source().nameKey | translate) }
        "
      >
        <img
          class="source-card__manage-icon"
          src="/public/svgs/chevron-right.svg"
          alt=""
          width="16"
          height="16"
          aria-hidden="true"
        />
      </a>
    } @else {
      <span
        class="source-card__manage source-card__manage--placeholder"
        aria-hidden="true"
      ></span>
    }
  </div>
</article>
